import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export type StatusFilter = "all" | "active" | "inactive";

export interface FilterByStatusProps {
    /** Current filter value */
    value: StatusFilter;
    /** Callback when filter changes */
    onChange: (value: StatusFilter) => void;
    /** Optional label for the filter (default: "Status") */
    label?: string;
}

/**
 * Filter-by-status select dropdown.
 * Provides options to filter by All, Active, or Inactive status.
 */
const FilterByStatus: React.FC<FilterByStatusProps> = ({
    value,
    onChange,
    label = "Status",
}) => {
    return (
        <FormControl size="small" sx={{ minWidth: 120, flexShrink: 0 }}>
            <InputLabel id="filter-status-label">{label}</InputLabel>
            <Select
                labelId="filter-status-label"
                label={label}
                value={value}
                onChange={(e) => onChange(e.target.value as StatusFilter)}
            >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
        </FormControl>
    );
};

export default FilterByStatus;

